import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const CurrencyTransfer = ({
  size,
  type,
  theme,
  className,
  dataTestId = "currency-transfer-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M7.645 13.569a.667.667 0 0 1-.943.003l-1.806-1.797a.665.665 0 0 1 .003-.947l1.818-1.797a.667.667 0 1 1 .936.947l-.663.655h3.65a.667.667 0 1 1 0 1.333H6.981l.662.66c.26.259.261.681.001.943ZM9.298 3.25a.667.667 0 0 0-.942.947l.663.66H5.36a.667.667 0 0 0 0 1.333H9.01l-.663.655a.667.667 0 1 0 .936.947l1.818-1.797a.669.669 0 0 0 .003-.947L9.298 3.251Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.74 1.534C1.74.798 2.337.2 3.073.2h6.967c.368 0 .719.151.97.419l2.888 3.065c.233.247.363.574.363.914v10.033c0 .737-.597 1.334-1.333 1.334H3.072a1.333 1.333 0 0 1-1.333-1.334V1.534Zm8.3 0H3.073v13.098h9.854V4.6L10.04 1.534Z"
    />
  </SVGIcon>
);
